/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

import chartsImg from './images/charts.svg';
import {BLOCK_HEIGHT} from '../../constants';

interface RootProps {
  overrideHeight?: string;
}

export const Root = styled(Button, {
  shouldForwardProp: prop => prop !== 'overrideHeight',
})<RootProps>(({theme, overrideHeight}) => ({
  width: '100%',
  height: overrideHeight || BLOCK_HEIGHT,
  minWidth: 'max-content',

  position: 'relative',
  borderRadius: '8px',
  overflow: 'hidden',
  background: theme.palette.semantic_dark?.surface.surface1,

  '&:hover': {
    background: theme.palette.semantic_dark?.surface.surface1,
  },
}));

interface ContentProps {
  hover: boolean;
}

export const HoverBg = styled(Box, {
  shouldForwardProp: prop => prop !== 'hover',
})<ContentProps>(({theme, hover}) => ({
  width: '100%',
  height: '100%',
  background: theme.palette.semantic_dark?.surface.surface3,
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 1,
  opacity: hover ? 1 : 0,
  transition: '0.2s',
}));

export const TextBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  position: 'relative',
  zIndex: 2,
}));

export const ImageBox = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 0,

  backgroundImage: `url(${chartsImg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
}));

export const ButtonText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));
